import React from "react";
import {Box, Flex, Image, Link, Text, HStack} from "@chakra-ui/react";
import {FaFacebook, FaYoutube, FaLinkedin} from "react-icons/fa";
import {Tooltip} from "./ui/tooltip";
import LegalModal from "./LegalModal"; // Adjust the path as necessary

const Footer = () => {
    return (
        <Box bg="white" color="black" py={8} px={4} borderTop="1px solid" borderColor="gray.200">
            <Flex
                maxW="1200px"
                mx="auto"
                align="center"
                justify="space-between"
                direction={{ base: "column", md: "row" }}
                gap={{ base: 4, md: 0 }}
            >
                {/* Left: Logo */}
                <Link
                    href="https://www.tier-wohl-team.de"
                    isExternal
                    target="_blank"
                    rel="noopener noreferrer"
                    _hover={{transform: "scale(1.1)"}} // YouTube hover color

                >
                    <Image
                        src="./TWT_Logo.png"
                        alt="TierWohl Team Logo"
                        style={{height: "50px"}}
                    />
                </Link>

                {/* Center: Social Links */}
                <HStack spacing={6} justify="center">
                    <Link
                        href="https://www.facebook.com/jorg.schultz.9028"
                        isExternal
                        target="_blank"
                        rel="noopener noreferrer"
                        _hover={{transform: "scale(1.1)", color: "blue.500"}} // Facebook hover color
                    >
                        <Tooltip content="Visit my Facebook Page">
                            <FaFacebook size={24} color="#1877F2"/>{/* Facebook brand color */}
                        </Tooltip>
                    </Link>
                    <Link
                        href="https://www.linkedin.com/in/j%C3%B6rg-schultz-b56a7116b/"
                        isExternal
                        target="_blank"
                        rel="noopener noreferrer"
                        _hover={{ transform: "scale(1.1)", color: "blue.700" }}
                    >
                        <Tooltip content="Visit my LinkedIn Profile">
                            <FaLinkedin size={24} color="#0A66C2" />
                        </Tooltip>
                    </Link>
                    <Link
                        href="https://www.youtube.com/@tierwohlteamgbr9844"
                        isExternal
                        target="_blank"
                        rel="noopener noreferrer"
                        _hover={{transform: "scale(1.1)", color: "red.500"}} // YouTube hover color
                    >
                        <Tooltip content="Visit the Tier Wohl Team YouTube Channel">
                            <FaYoutube size={24} color="#FF0000"/>
                        </Tooltip>
                    </Link>
                </HStack>

                {/* Legal Modals */}
                <HStack spacing={6}>
                    <LegalModal type="Impressum" triggerText="Impressum" />
                    <LegalModal type="AGB" triggerText="AGB" />
                    <LegalModal type="DSGVO" triggerText="DSGVO" />
                </HStack>
            </Flex>

            <Text fontSize="sm" textAlign="center" mt={4}>
                © 2025 Tier Wohl Team GbR. All rights reserved.
            </Text>
        </Box>
    );
};

export default Footer;